"use client";

import { Slot, classed, clsx } from "@frend-digital/ui";
import type { ComponentProps } from "react";
import { useFormContext } from "react-hook-form";
import styles from "./Input.module.css";

export interface InputProps extends ComponentProps<"input"> {}

export const Input = ({ className, ...props }: InputProps) => {
	return <input className={clsx(styles.root, className)} {...props} />;
};

export type TextFieldProps = InputProps & {
	label: React.ReactNode;
	error?: string;
	asChild?: boolean;
};

export const TextField = ({ error, asChild, children, className, ...rest }: TextFieldProps) => {
	const Component = asChild ? Slot : Input;
	return (
		// biome-ignore lint/a11y/noLabelWithoutControl: <explanation>
		<label className={clsx(styles.label, className)}>
			<span className={styles.labelText}>{rest.label}</span>
			<Component {...rest}>{children}</Component>
			{error && <span className={styles.error}>{error}</span>}
		</label>
	);
};

export const Label = classed.label(styles.label);
export const LabelText = classed.span(styles.labelText);

export type FormFieldProps = TextFieldProps & {
	name: string;
};

export const FormField = ({ name, ...rest }: FormFieldProps) => {
	const {
		register,
		formState: { errors },
	} = useFormContext();
	return <TextField {...rest} {...register(name)} error={errors[name]?.message?.toString()} />;
};
